import { styled } from '@mui/material';

export const DetailsEditToolbar = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
  marginBottom: 4,
});

export const DetailsHeaderRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
});

export const DetailsActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  marginTop: 4,
});

export const DetailsActionsButtons = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 8,
});

export const DetailsActionButton = styled('button')(({ theme }) => ({
  borderRadius: 6,
  padding: '6px 12px',
  fontSize: 13,
  lineHeight: 1.2,
  cursor: 'pointer',
  border: `1px solid ${theme.palette.novotalk.$resourcesTableBorderColor}`,
  backgroundColor: theme.palette.novotalk.$outlineButtonColorReversed,
  color: theme.palette.novotalk.$textColor,
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
}));

export const DetailsPrimaryButton = styled(DetailsActionButton)(({ theme }) => ({
  backgroundColor: theme.palette.novotalk.$actionButtonColor,
  color: theme.palette.novotalk.$outlineButtonColorReversed,
  border: `1px solid ${theme.palette.novotalk.$actionButtonColor}`,
}));

export const DetailsField = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

export const DetailsInlineRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
});

export const DetailsSelect = styled('select')(({ theme }) => ({
  height: 34,
  borderRadius: 6,
  border: `1px solid ${theme.palette.novotalk.$resourcesTableBorderColor}`,
  padding: '0 10px',
  background: '#fff',
  color: theme.palette.novotalk.$textColor,
}));

export const DetailsHint = styled('div')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.novotalk.$descriptionColor,
}));

export const DetailsError = styled('div')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.error.main,
}));
